import { useEffect, useState } from 'react';
import DataTable from '../lib/DataTable';
import { useLocation } from 'react-router-dom';

interface HistoryEntry {
    path: string;
    name?: string;
}

const columns = [
    {
        id: 'recentlyviewed',
        name: 'Recently Viewed',
        valueAccessor: (row: HistoryEntry) => row.name,
        navigateOnClick: (row: HistoryEntry) => row.path
    }
];

function arrayContains(arr: HistoryEntry[], obj: HistoryEntry) {
    for (let i = 0; i < arr.length; i++) {
        if (arr[i].path === obj.path) {
            return true;
        }
    }
    return false;
}

function moveToTop(arr: HistoryEntry[], obj: HistoryEntry) {
    let i = 0;
    while (i < arr.length) {
        if (arr[i].path === obj.path) {
            break;
        }
        i++;
    }
    const temp = Array.from(arr);
    temp.splice(i, 1);
    return [obj, ...temp];
}

function storeHistoryForPath(pathname: string) {
    const paths = ['/team', '/tournament', '/game', '/person'];
    for (let i = 0; i < paths.length; i++) {
        if (pathname.startsWith(paths[i])) {
            return true;
        }
    }
    return false;
}

const teamPathRegex = /\/team\/[^/]+/;

export default function RecentlyViewed(props: { name?: string }) {
    const location = useLocation();
    const [history, setHistory] = useState<HistoryEntry[]>([]);
    const [title, setTitle] = useState('');

    useEffect(() => {
        const historyObj: HistoryEntry = {
            path: location.pathname,
            name: title
        };
        if (!storeHistoryForPath(location.pathname)) {
            return;
        } else if (location.pathname.startsWith('/team')) {
            historyObj.path = location.pathname.match(teamPathRegex)![0];
        }
        if (arrayContains(history, historyObj)) {
            const temp = moveToTop(history, historyObj);
            setHistory(temp);
        } else if (history.length < 15) {
            setHistory([historyObj, ...history]);
        } else {
            const temp = Array.from(history);
            temp.pop();
            setHistory([historyObj, ...temp]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [title]);

    useEffect(() => {
        setTitle(props.name || '');
    }, [props.name]);

    useEffect(() => {
        const sessionHistory = JSON.parse(sessionStorage.getItem('history') || 'null');
        if (sessionHistory !== null) {
            sessionStorage.setItem('history', sessionHistory);
            setHistory(sessionHistory);
        }
    }, []);

    useEffect(() => {
        sessionStorage.setItem('history', JSON.stringify(history));
    }, [history]);

    return history.length > 0 ? (
        <div className="w-full">
            <DataTable rows={history} columns={columns} />
        </div>
    ) : null;
}
